module.exports = __webpack_public_path__ + "img/OPEN_NEW_TAB.11a210cd.svg";